export default __webpack_public_path__ + "static/paloatlo-8bde21ca150ddc30a26b4ab23ece6951.png";